import { render, staticRenderFns } from "./PanRoleEdit.vue?vue&type=template&id=d8633a90&scoped=true"
import script from "./PanRoleEdit.vue?vue&type=script&lang=js"
export * from "./PanRoleEdit.vue?vue&type=script&lang=js"
import style0 from "./PanRoleEdit.vue?vue&type=style&index=0&id=d8633a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8633a90",
  null
  
)

export default component.exports